<template>
  <div>
    <img class="profileImage" :src="photoURL" width="250" height="250">
  </div>
</template>

<script>
import {
  messageMixin
} from '@/mixins/messageMixin.js'
export default {
  mixins: [messageMixin],
  computed: {
    photoURL () {
      let photoURL = this.$store.state.session.user.PhotoURL
      if (photoURL === undefined) {
        return ''
      }
      if (photoURL.includes('http') || photoURL.includes('nophoto.png')) {
        return photoURL
      } else {
        let key = '6a61e395-b49a-4468-bee0-27644e95308f'
        var iv = key.split('').reverse().join('')
        let encryptedBody = this.ewk(photoURL, key, iv)
        return process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + photoURL + '&s=' + encodeURIComponent(encryptedBody)
      }
    }
  }
}

</script>
